import React, { useState, useEffect, Fragment } from "react";
import {
  Alert,
  Image,
  ImageBackground,
  Modal,
  Platform,
  SafeAreaView,
  ScrollView,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import typo from "../../Theme/Typo";
import Colors from "../../Theme/Colors";
import { useTranslation } from "react-i18next";
import { TextInput } from "react-native-paper";
import { AntDesign } from "@expo/vector-icons";
import Queries from "../../api/queries";
import LoadingModal from "../LoadingModal";
import Button from "../Button";
import Mutation from "../../api/mutation";
import RootStore from "../../Store";
import * as ImagePicker from "expo-image-picker";
import Entypo from "@expo/vector-icons/Entypo";
import FontAwesome from "@expo/vector-icons/FontAwesome";
import ImageViewer from "react-native-image-zoom-viewer";

// NEW CAMERA SCREEN
import CameraScreen from "../CameraScreen";
import ModalQLerr from "../../utils/ModalQLerr";
import AlertCustom from "../utils/alert";

const BG_PATH = require("../../../assets/newDesign/background-portrait.png");

const { userInfo } = RootStore.getInstance();

const AddProblem = ({ navigation, route }) => {
  const [QLerror, setQLerror] = useState("");

  const [isLoading, setLoading] = useState<boolean>(false);
  const [titleError, setTitleError] = useState<boolean>(false);
  const [descriptionError, setDescriptionError] = useState<boolean>(false);
  const [title, setTitle] = useState<string>("");
  const [description, setDescription] = useState<string>("");
  const [pictures, setPictures] = useState<Array<any>>([]);
  const [MediaAvailable, setMediaAvailable] = useState(false);
  const [isViewer, setViewer] = useState({
    isVisible: false,
    index: 0,
  });

  const [CameraOpen, setCameraOpen] = useState(false);

  const mutation = new Mutation();

  const {
    eventId = "",
    problem = {},
    refreshPicture = () => {},
  } = route.params;

  const { t } = useTranslation();

  const addPicture = (picture: object) => {
    const temp = [...pictures];
    if(picture?.assets?.[0]) temp.push({ uri: picture.assets[0].uri, base64: picture.assets[0].base64 });
    setPictures(temp);
  };

  const deletePicture = (index: any) => {
    AlertCustom(
      t("RERMOVE_ACHAT_CONFIRM_TITLE"),
      t("RERMOVE_PICTURE_CONFIRM_BODY"),
      [
        // The "Yes" button
        {
          text: t("RERMOVE_ACHAT_CONFIRM_YES"),
          onPress: () => {
            const temp = [...pictures];
            temp.splice(index, 1);
            setPictures(temp);
          },
        },
        // The "No" button
        {
          text: t("RERMOVE_ACHAT_CONFIRM_FALSE"),
        },
      ]
    );
  };

  useEffect(() => {
    (async () => {
      // Pictures library permission
      const { granted: mediaGranted = false } =
        await ImagePicker.requestMediaLibraryPermissionsAsync();

      if (mediaGranted) {
        setMediaAvailable(true);
      } else {
        AlertCustom(
          t("TITLE_MSG_PERMISSION_DENIED"),
          t("MSG_PERMISSION_MEDIA_DENIED")
        );
      }
    })();
    if (problem.title && problem.description) {
      setTitle(problem.title);
      setDescription(problem.description);
      setPictures(
        problem.image.length > 0
          ? problem.image.map((image) => ({ uri: image }))
          : []
      );
    }
  }, []);

  const pickImage = async () => {
    let result = await ImagePicker.launchImageLibraryAsync({
      mediaTypes: ImagePicker.MediaTypeOptions.Images,
      allowsEditing: false,
      base64: true,
      quality: 0.5,
    });
    if (!result.cancelled) {
      setLoading(true);
      addPicture(result);
    }
    setLoading(false);
  };

  const submitIncident = async () => {
    setLoading(true);

    if (title == "" || description == "") {
      if (title == "") {
        setTitleError(true);
      } else if (titleError == true) {
        setTitleError(false);
      }
      if (description == "") {
        setDescriptionError(true);
      } else if (descriptionError == true) {
        setDescriptionError(false);
      }
      AlertCustom(t("ERROR"), t("TITLE_DESC_MISSING_PROBLEM"));
      setLoading(false);
    } else {
      try {
        const data = await mutation.addProblem(
          eventId,
          title,
          description,
          pictures.map((picture) =>
            picture.base64 ? picture.base64 : "EDIT:" + picture.uri
          ),
          userInfo.getToken()
        );

        let errors = data?.errors;

        if (errors && errors.length > 0) {
          const errorMessage: string = errors[0].message;

          setQLerror(errorMessage);
        }
      } catch (err) {
        setQLerror(err);
      } finally {
        refreshPicture();
        navigation.goBack();
        setLoading(false);
      }
    }
  };

  return (
    <SafeAreaView style={typo.mainBackground}>
      <ImageBackground source={BG_PATH} style={typo.background}>
        <ScrollView>
          <Modal
            visible={CameraOpen}
            onRequestClose={() => setCameraOpen(false)}
          >
            <CameraScreen
              closeCamera={() => setCameraOpen(false)}
              isChat={false}
              pictures={pictures}
              setPictures={setPictures}
            />
          </Modal>
          {QLerror && QLerror !== "" ? (
            <ModalQLerr reason={QLerror} resetErr={() => setQLerror("")} />
          ) : null}
          <Fragment>
            {isLoading && <LoadingModal loading={isLoading || isLoading} />}
            <View style={typo.container}>
              <Text style={typo.titleInfo}>{t("PROBLEM_TITLE")}</Text>
              <View style={typo.resCard}>
                <View style={typo.underlineCat}>
                  <AntDesign
                    name="picture"
                    size={25}
                    style={{ marginRight: 10 }}
                    color={Colors.oiqia}
                  />
                  <Text style={typo.category}>
                    {t("PROBLEM_DESCRIPTION_TITLE")}
                  </Text>
                </View>
                <View>
                  <TextInput
                    activeOutlineColor={Colors.oiqia}
                    value={title}
                    label={t("PROBLEM_TITLE_LABEL")}
                    style={{
                      marginTop: 10,
                      marginBottom: 10,
                      backgroundColor: "white",
                    }}
                    mode="outlined"
                    onChangeText={setTitle}
                    error={titleError}
                  />
                  <TextInput
                    activeOutlineColor={Colors.oiqia}
                    value={description}
                    label={t("PROBLEM_DESCRIPTION_LABEL")}
                    style={{
                      marginTop: 10,
                      marginBottom: 10,
                      backgroundColor: "white",
                    }}
                    mode="outlined"
                    onChangeText={setDescription}
                    multiline
                    error={descriptionError}
                  />
                </View>
              </View>
              <View style={typo.resCard}>
                <View style={typo.underlineCat}>
                  <AntDesign
                    name="picture"
                    size={25}
                    style={{ marginRight: 10 }}
                    color={Colors.oiqia}
                  />
                  <Text style={typo.category}>
                    {t("PROBLEM_PICTURE_TITLE")}
                  </Text>
                </View>
                <View style={typo.catCard}>
                  {pictures.length > 0 ? (
                    <ScrollView horizontal>
                      {pictures.map((element, index) => (
                        <View key={index} style={{ margin: 5 }}>
                          <TouchableOpacity
                            onPress={() =>
                              setViewer({ isVisible: true, index })
                            }
                          >
                            <Image
                              style={style.image}
                              source={{ uri: element.uri }}
                            />
                          </TouchableOpacity>
                          <View style={{ alignSelf: "center" }}>
                            <FontAwesome
                              name="trash"
                              size={24}
                              color={Colors.red}
                              onPress={() => deletePicture(index)}
                            />
                          </View>
                        </View>
                      ))}
                    </ScrollView>
                  ) : (
                    <View style={{ alignSelf: "center" }}>
                      <Text style={typo.body}>
                        {t("PROBLEM_PICTURES_EMPTY")}
                      </Text>
                    </View>
                  )}
                </View>
                <View
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-around",
                    marginTop: 10,
                    alignItems: "center",
                  }}
                >
                  <TouchableOpacity
                    style={style.colImg}
                    onPress={() => setCameraOpen(true)}
                  >
                    <AntDesign name="camera" size={30} color={Colors.oiqia} />
                    <Text>{t("PROBLEM_PICTURE_TAKE")}</Text>
                  </TouchableOpacity>
                  <TouchableOpacity
                    style={style.colImg}
                    disabled={!MediaAvailable}
                    onPress={() => pickImage()}
                  >
                    <AntDesign
                      name="picture"
                      size={30}
                      color={MediaAvailable ? Colors.oiqia : Colors.black}
                    />
                    <Text>{t("PROBLEM_PICTURE_PICK")}</Text>
                  </TouchableOpacity>
                </View>
                {Platform.OS != "web" && pictures.length > 0 && (
                  <SafeAreaView style={{ flex: 1 }}>
                    <Modal visible={isViewer.isVisible} transparent={true}>
                      <ImageViewer
                        key={isViewer.index}
                        enableSwipeDown={true}
                        index={isViewer.index}
                        imageUrls={pictures.map((ele) => {
                          return {
                            url: ele.uri,
                            props: { source: ele.uri },
                          };
                        })}
                        renderHeader={() => (
                          <SafeAreaView>
                            <TouchableOpacity
                              onPress={() =>
                                setViewer({ isVisible: false, index: 0 })
                              }
                            >
                              <Entypo
                                name="cross"
                                onPress={() =>
                                  setViewer({ isVisible: false, index: 0 })
                                }
                                size={60}
                                color="white"
                              />
                            </TouchableOpacity>
                          </SafeAreaView>
                        )}
                      ></ImageViewer>
                    </Modal>
                  </SafeAreaView>
                )}
              </View>
              {!MediaAvailable && (
                <View style={typo.resCard}>
                  <Text style={style.cautionMessage}>
                    Vous n'avez pas autorisé l'application à accéder à votre
                    galerie photo
                  </Text>
                  <Text style={style.cautionMessage}>
                    {"\n"}Vous pouvez changer ces paramètres via les réglages de
                    votre appareil
                  </Text>
                </View>
              )}
              <View>
                <Button
                  text="Envoyer"
                  style={{
                    alignSelf: "center",
                    backgroundColor: Colors.oiqia,
                    marginTop: 10,
                  }}
                  onPress={() => submitIncident()}
                />
              </View>
            </View>
          </Fragment>
        </ScrollView>
      </ImageBackground>
    </SafeAreaView>
  );
};

const style = StyleSheet.create({
  center: {
    flex: 1,
    justifyContent: "flex-end",
  },
  titleWelcome: {
    fontSize: 18,
    color: "black",
    textAlign: "center",
    alignItems: "center",
    justifyContent: "center",
    fontFamily: "RobotoMedium",
  },
  container: {
    flex: 1,
    backgroundColor: "#fff",
  },
  column: {
    flex: 1,
    alignSelf: "auto",
    justifyContent: "space-between",
    flexDirection: "row",
  },
  dateInfo: {
    width: "50%",
    padding: 5,
    textAlign: "left",

    justifyContent: "flex-start",
  },
  underline: {
    borderColor: "#0A0A0AE7",
    borderBottomWidth: 0.5,
    paddingBottom: 5,
    marginBottom: 10,
  },
  item: {
    marginTop: 10,
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
  },
  textCheckBox: {
    maxWidth: 320,
  },
  colImg: {
    alignItems: "center",
    marginBottom: -10,
  },
  image: {
    left: 5,
    top: 5,
    width: 200,
    height: 150,
    borderWidth: 1,
    borderRadius: 1,
    marginRight: 10,
    borderColor: "white",
    marginBottom: 5,
  },
  cautionMessage: {
    color: "red",
  },
});

export default AddProblem;
